import type { VideoHTMLAttributes } from 'react';

import type { VideoComponentProps } from './VideoComponent';

export const mergeHtmlVideoProps = (
  video: VideoComponentProps | null | undefined,
  overrides: VideoHTMLAttributes<HTMLVideoElement> = {},
): VideoHTMLAttributes<HTMLVideoElement> => ({
  ...(video?.htmlVideoProps ?? {}),
  ...overrides,
  style: {
    ...(video?.htmlVideoProps?.style ?? {}),
    ...(overrides.style ?? {}),
  },
});
